<div
  style="
    display: flex;
    flex-direction: column;
    height: 100%;
  "
>
  <div class="table-wrapper">
    <app-dunning-config-table
      (editedRowChange)="filterDunningLevels($event)"
    />
  </div>

  @if (!dunningConfigSelectedSource() && alertObjects().length > 0) {
    <div style="flex: 1; overflow: auto;">
      {{getAlertOverview()}}
    </div>
  }

  @if (dunningConfigSelectedSource()) {
    <app-dunnings-editor
      style="flex: 1; overflow: hidden;"
      [parent]="dunningConfigSelectedSource()"
      (defaultLanguageConfigured)="refetchAlertObjects()"
    />
  }
</div>
